import React, { useState, useEffect, useRef } from 'react'
// import { jwtDecode } from "jwt-decode"
import jwt_decode from "jwt-decode"
import { throttle } from 'lodash'

import { RightOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import DividerWithText from "./Common/components/DividerLineWithText"
import { useStatsigClient } from "@statsig/react-bindings/src";
import { updateStatsigUser } from "./statsig/statsigMethod"
import { track, flushThenLeave } from 'statsig'
import { STATSIG } from 'statsig/events'
import { syncLoTokenToStrataCookies } from "./syncStrataSession.js"

function trackLoginFail(type, { reason = 'error', errorText } = {}) {
    track(STATSIG.AUTH.LOGIN_FAIL, type, {
        type,
        reason,
        ...(errorText ? { error_text: String(errorText).slice(0, 200) } : {}),
    })
}

function LoginPage({ setLoading, onSuccess, onToSignUp }) {
    const [showLine, setLine] = useState(false)
    const [userEmail, setUserEmail] = useState("")
    const [showChooseCompany, setShowChooseCompany] = useState(false)
    const [showAccountNotFound, setShowAccountNotFound] = useState(false)
    const [company, setCompany] = useState([
    ])
    const { client } = useStatsigClient();


    const renderGoogleBtn = () => {
        // 渲染隐藏的Google官方按钮
        google.accounts.id.renderButton(
            document.getElementById("hiddenGoogleSignin"),
            {
                width: '0',
                height: '0',
                text: 'signin_with',
                size: 'large',
                shape: 'pill',
                logo_alignment: 'center',
                theme: 'outline',
                type: 'standard'
            }
        )
        setLine(true)
    }

    const handleGoogleSignIn = () => {
        // 点击隐藏的Google官方按钮来触发登录
        const hiddenButton = document.getElementById("hiddenGoogleSignin");
        if (hiddenButton) {
            const googleButton = hiddenButton.querySelector('div[role="button"]');
            if (googleButton) {
                googleButton.click();
            } else {
                // 如果找不到按钮，回退到prompt方法
                google.accounts.id.prompt();
            }
        } else {
            // 如果找不到容器，回退到prompt方法
            google.accounts.id.prompt();
        }
    }

    const handleGoogleCallback = (response) => {

        let userObject = jwt_decode(response.credential)
        setLoading(true)
        setUserEmail(userObject.email)

        fetch("/los/googlesignin", {
            method: "POST",
            body: JSON.stringify(userObject),
            headers: {
                "Content-Type": "application/json",
                "X-GOOGLETOKEN": response.credential,

            },
        })
            .then((response) => {
                if (response.status !== 200) {
                    trackLoginFail('google', {
                        errorText: `HTTP ${response.status}`,
                    })
                    alert(
                        "Sorry, but we are unable to sign you in using your Google account at this time. Please consider using alternative sign-in methods."
                    )
                    setLoading(false)
                    return
                }
                response.json().then(async (js) => {
                    if (js.Status !== "OK") {
                        console.log("Error: " + js.Text)
                        trackLoginFail('google', { errorText: js.Text || js.Error })
                        alert('Sorry, but we are unable to sign you in using your Google account at this time. Please consider using alternative sign-in methods.')
                        // setMsg('')
                        // setShow(true)
                        sessionStorage.removeItem("ZeitroA")
                        sessionStorage.removeItem("state")
                        setLoading(false)
                    } else {
                        const { Claims } = js
                        if (!Claims || Claims.length === 0) {
                            // 因为没有注册，所以引导用户去注册
                            trackLoginFail('google', { reason: 'account_not_found' })
                            onToSignUp ? onToSignUp(userObject.email) : setShowAccountNotFound(true)

                        } else if (Claims.length === 1) {
                            sessionStorage.setItem("ZeitroA", Claims[0].Claim)
                            syncLoTokenToStrataCookies(Claims[0].Claim)
                            const payload = jwt_decode(Claims[0].Claim)
                            updateStatsigUser(client, userObject.email.toLowerCase().trim(), payload.customerid, {
                                orgName: Claims[0].CompanyName,
                            })
                            track(STATSIG.AUTH.LOGIN, 'google', { type: 'google' })
                            localStorage.setItem("customerid", payload.customerid)
                            await flushThenLeave(() => {
                                if(onSuccess) {
                                    onSuccess();
                                    return
                                }
                                
                                // 检查是否有保存的原始 URL
                                const redirectAfterLogin = sessionStorage.getItem("redirectAfterLogin")
                                if (redirectAfterLogin) {
                                    // 清除保存的 URL
                                    sessionStorage.removeItem("redirectAfterLogin")
                                    // 跳转到原始 URL
                                    window.location.href = redirectAfterLogin
                                } else {
                                    window.location.href = "/app/welcome"
                                }
                            })

                        } else {
                            setShowChooseCompany(true)
                            setCompany(Claims)
                        }

                        // history.push('/application/myloans')
                        setLoading(false)
                    }
                })
            })
            .catch(function (err) {
                trackLoginFail('google', {
                    errorText: err?.message || String(err),
                })
                console.log("Fetch Error :-S", err)
                setLoading(false)
            })
    }

    useEffect(() => {
        /* global google */
        if(!google?.accounts?.id?.initialize) return;
        google.accounts.id.initialize({
            client_id: "265683149831-9a27eaupjqjt6vh5vuaa54bfld627fre.apps.googleusercontent.com",
            callback: handleGoogleCallback,
        })
        renderGoogleBtn()
        return () => {
            setLine(false)
        }

    }, [])

    const displayAccountNotFoundModal = () => {
        if (showAccountNotFound) {
            return <Modal
                keyboard={false}
                className="chooseCompany-modal"
                title='Account not found'
                open={showAccountNotFound}
                footer={null}
                onCancel={() => {
                    setShowAccountNotFound(false)
                }}
            >
                <div className="py-4">
                    <div >The email address you used to sign in with Google is not associated with any accounts in our system. </div>
                    {window.location.hostname === "team.googain.com" ?
                        <div className="mt-2">Please contact your company administrator, or use a different email address.</div>
                        :
                        <div className="mt-2">Please
                        {onToSignUp ?
                            <span onClick={onToSignUp} style={{color:'#1677ff',cursor: 'pointer'}}>&nbsp;sign up a new account</span>
                            : <a href="https://lo.zeitro.com/signup">sign up a new account</a>
                        }, or use a different email address.</div>
                    }
                </div>
            </Modal>
        }
        return ""
    }

    return (
        <div>
            {/* 隐藏的Google官方按钮容器 */}
            <div id="hiddenGoogleSignin" style={{ display: 'none' }}></div>
            <div className="google-signin-container" style={{
                width: '100%',
                maxWidth: window.innerWidth <= 768 ? '320px' : '400px',
                margin: '0 auto'
            }}>
                <button
                    type="button"
                    onClick={handleGoogleSignIn}
                    className="google-signin-button"
                    style={{
                        width: '100%',
                        height: '40px',
                        backgroundColor: '#fff',
                        border: '1px solid #dadce0',
                        color: '#222',
                        borderRadius: '24px',
                        fontSize: '18px',
                        lineHeight: '22px',
                        fontFamily: 'Inter',
                        fontWeight: '400',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        transition: 'all 0.2s ease',
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#f7f8ff';
                        e.currentTarget.style.border = '1px solid #d8eaff';
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = '#fff';
                        e.currentTarget.style.border = '1px solid #dadce0';
                    }}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                    >
                        <path
                            d="M21.56 11.25c0-.78-.07-1.53-.2-2.25H11v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                            fill="#4285F4"
                        />
                        <path
                            d="M11 22c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H1.17v2.84C2.99 19.53 6.7 22 11 22z"
                            fill="#34A853"
                        />
                        <path
                            d="M4.84 13.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V6.07H1.17C.42 7.3 0 8.6 0 10s.42 2.7 1.17 3.93l2.67-2.84.01-.01z"
                            fill="#FBBC05"
                        />
                        <path
                            d="M11 4.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C16.45 1.19 13.97 0 11 0 6.7 0 2.99 2.47 1.17 6.07l3.67 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                            fill="#EA4335"
                        />
                    </svg>
                    <span style={{ width: onToSignUp ? 190 : 177, textAlign: 'left'}}>{onToSignUp ? 'Continue with Google' : 'Sign in with Google'}</span>
                </button>
            </div>
            <Modal
                keyboard={false}
                className="chooseCompany-modal"
                title='Join the following orginizations'
                open={showChooseCompany}
                footer={null}
                onCancel={() => {
                    // this.editEmail('')
                    setShowChooseCompany(false)
                }
                }>
                {
                    (
                        <>
                            <div className="ft-500">is associated with accounts at the following orginizations, please select one to log in.</div>
                            <div className="chooseCompany-list">
                                {
                                    company.map((item, index) => (
                                        <div key={index} className="chooseCompany" onClick={async () => {
                                            sessionStorage.setItem("ZeitroA", item.Claim)
                                            syncLoTokenToStrataCookies(item.Claim)
                                            const payload = jwt_decode(item.Claim)
                                            updateStatsigUser(client, userEmail.toLowerCase().trim(), payload.customerid, {
                                                orgName: item.CompanyName,
                                            })
                                            track(STATSIG.AUTH.LOGIN, 'google', { type: 'google' })
                                            localStorage.setItem("customerid", payload.customerid)
                                            await flushThenLeave(() => {
                                                if(onSuccess) {
                                                    onSuccess();
                                                    return
                                                }
                                                
                                                // 检查是否有保存的原始 URL
                                                const redirectAfterLogin = sessionStorage.getItem("redirectAfterLogin")
                                                if (redirectAfterLogin) {
                                                    // 清除保存的 URL
                                                    sessionStorage.removeItem("redirectAfterLogin")
                                                    // 跳转到原始 URL
                                                    window.location.href = redirectAfterLogin
                                                } else {
                                                    window.location.href = "/app/welcome"
                                                }
                                                setShowChooseCompany(false)
                                            })
                                        }}>
                                            <div>{item.CompanyName}</div>
                                            <RightOutlined />
                                        </div>
                                    ))
                                }
                            </div>
                        </>
                    )
                }
            </Modal>
            {displayAccountNotFoundModal()}
            {/* {showLine ? <DividerWithText text="OR" /> : <></>} */}
        </div>
    )
}

export default LoginPage